import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class UtilServiceService {

  constructor() { }
  entEtiquetaModulo: Array<any> = [];
  entidadEtiqueta: Array<any> = [];  
  textoTipoOracion(text: string): string {
    let result = text[0].toUpperCase() + text.substr(1).toLowerCase();
    return result;
  }
  textoCadaPalabraMayuscula(text: string): string {
    const re = /(^|[^A-Za-zÁÉÍÓÚÜÑáéíóúüñ])(?:([a-záéíóúüñ])|([A-ZÁÉÍÓÚÜÑ]))|([A-ZÁÉÍÓÚÜÑ]+)/gu;
    return text.replace(re,
      (m, caracterPrevio, minuscInicial, mayuscInicial, mayuscIntermedias) => {
        const locale = ['es', 'gl', 'ca', 'pt', 'en'];
        if (mayuscIntermedias)
          return mayuscIntermedias.toLocaleLowerCase(locale);
        return caracterPrevio
          + (minuscInicial ? minuscInicial.toLocaleUpperCase(locale) : mayuscInicial);
      }
    );
  }
  public getStringEtiqueta(codigo: number, tipoTexto: number): any {    
    let valor = "";
    for (let etiqueta of this.entEtiquetaModulo) {
      if (etiqueta.co == codigo) {
        valor = tipoTexto == 1 ? this.textoTipoOracion(etiqueta.de) :
                                (tipoTexto == 2 ? this.textoCadaPalabraMayuscula(etiqueta.de) : etiqueta.de);
      }
    }
    if (valor == "") {
      for (let etiqueta of this.entidadEtiqueta) {
        if (etiqueta.co == codigo) {
          valor = tipoTexto == 1 ? this.textoTipoOracion(etiqueta.de) :
                          (tipoTexto == 2 ? this.textoCadaPalabraMayuscula(etiqueta.de) : etiqueta.de);
        }
      }
    }    
    return valor;
  }
  public downloadPdf(filePdf: any, filename: string) {
    const downloadLink = document.createElement("a");
    const fileName =filename + ".pdf";
    downloadLink.href = filePdf;
    downloadLink.download = fileName;
    downloadLink.click()
  }
}
